// Você não deve entender isso, não sei porque eu fiz isso.

import { ThunkAction } from 'redux-thunk'
import { StoreState } from 'store'
import { PaymentAction, PaymentActionTypes } from './paymentTypes'
import apiRest from '../../services/apiRest'
import errorHandler from '../../errorHandler'

export function getPayment(): ThunkAction<
  Promise<void>,
  StoreState,
  undefined,
  PaymentAction
> {
  return async (dispatch, getState) => {
    try {
      const { selectedChurchIndex, user } = getState().sessionState
      const churchId = user?.churches?.[selectedChurchIndex]?.id
      dispatch({
        type: PaymentActionTypes.GET_PAYMENT_START,
      })

      const { data: payment } = await apiRest({
        method: 'get',
        url: 'payment',
        params: {
          churchId,
        },
      })

      dispatch({
        type: PaymentActionTypes.GET_PAYMENT_SUCCESS,
        payment,
      })
    } catch (error) {
      errorHandler(error)
      dispatch({
        type: PaymentActionTypes.GET_PAYMENT_ERROR,
      })
    }
  }
}
